import React from 'react';
import LoadingV2 from '../../../atoms/loader/LoadingV2';
import styled from '@emotion/styled';
import { getBackgroundTheme } from '../../../style';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const Container = styled('div')(() => ({
  position: 'fixed',
  width: '100vw',
  height: '110vh',
  background: getBackgroundTheme().surface,
  left: 0,
  top: 0,
  zIndex: 995,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#FFF',
  textAlign: 'center',
  marginTop: 0,
}));

const LoadingContent = styled('div')({});

const LoadingLabel = styled('div')({
  color: '#FFF',
  textAlign: 'center',
});

interface IBillingLoadingProps {
  isLoading: boolean;
  showLabel?: boolean;
  label?: string | null;
}

const BillingLoading: React.FC<IBillingLoadingProps> = ({
  isLoading = false,
  showLabel = true,
  label = 'Loading...',
}) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Container>
      <LoadingContent>
        <LoadingV2 />
        {showLabel && <LoadingLabel>{label}</LoadingLabel>}
      </LoadingContent>
    </Container>
  );
};

export default BillingLoading;
